"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMenu = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("../Button"));
const Menu_1 = __importDefault(require("../Menu"));
function IconMenu(props) {
    const { anchorOrigin = { vertical: 'bottom', horizontal: 'right' }, transformOrigin = { vertical: 'top', horizontal: 'right' }, children, minWidth } = props, otherProps = __rest(props, ["anchorOrigin", "transformOrigin", "children", "minWidth"]);
    const [menuAnchorEl, setMenuAnchorEl] = (0, react_1.useState)();
    const handleMenuOpen = (0, react_1.useCallback)((e) => {
        if (e)
            e.stopPropagation();
        setMenuAnchorEl(e.currentTarget);
    }, []);
    const handleMenuClose = (0, react_1.useCallback)((e) => {
        if (e)
            e.stopPropagation();
        setMenuAnchorEl(null);
    }, []);
    const handleClick = (0, react_1.useCallback)(e => {
        if (!props.doNotCloseOnClick)
            handleMenuClose(e);
        e.stopPropagation();
    }, [handleMenuClose, props.doNotCloseOnClick]);
    const renderButton = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(Button_1.default, Object.assign({ nowrap: true, "aria-owns": !!menuAnchorEl ? 'material-appbar' : undefined, "aria-haspopup": "true", onClick: handleMenuOpen }, otherProps)));
    }, [handleMenuOpen, menuAnchorEl, otherProps]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        renderButton,
        react_1.default.createElement(Menu_1.default, { minWidth: minWidth, anchorEl: menuAnchorEl, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, open: !!menuAnchorEl, onClick: handleClick, onClose: handleMenuClose }, children)));
}
exports.IconMenu = IconMenu;
exports.default = IconMenu;
